import { ContactData } from '../components/features/ContactForm';

interface ParsedFields {
  name?: string;
  phone?: string;
  email?: string;
  title?: string;
  organization?: string;
  address?: string;
  website?: string;
  notes?: string;
}

export const parseTranscription = (text: string): Partial<ContactData> => {
  const parsed: ParsedFields = {};
  
  // Clean up the text first
  text = text.replace(/^might put a /i, '').trim();
  
  // Name patterns
  const namePatterns = [
    // Look for name anywhere in the text
    /\b([A-Z][a-z]+ [A-Z][a-z]+)\b/i,
    // Original patterns remain as fallback
    /(?:my|the|this is|name is|i am|i'm) ([A-Z][a-z]+ [A-Z][a-z]+)(?=\s|$|\.|,)/i,
    /([A-Z][a-z]+ [A-Z][a-z]+) (?:speaking|here)(?=\s|$|\.|,)/i,
    /name(?:'s| is)? ([A-Z][a-z]+ [A-Z][a-z]+)(?=\s|$|\.|,)/i
  ];

  // Phone patterns
  const phonePatterns = [
    // Direct number pattern (most common)
    /\b(\d{10})\b/,
    // Number with spaces or punctuation
    /\b(\d{4}[\s.-]?\d{3}[\s.-]?\d{3})\b/,
    // Original patterns
    /(?:phone|number|tel|telephone|cell|mobile).+?(\d[\d\s-().]+\d)/i,
    /(\d{3}[-.)]\s*\d{3}[-.)]\s*\d{4})/
  ];

  // Try to find name and phone in the text
  const phoneMatch = text.match(/\b(\d{10})\b/);
  if (phoneMatch) {
    parsed.phone = phoneMatch[1];
    // The name might be everything before the phone number
    const beforePhone = text.slice(0, text.indexOf(phoneMatch[1])).trim();
    if (beforePhone) {
      // Clean up any punctuation and try to format as a name
      const cleanName = beforePhone.replace(/[,.]/g, '').trim();
      const words = cleanName.split(/\s+/);
      if (words.length >= 2) {
        // Capitalize each word
        parsed.name = words.map(word => 
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ');
      }
    }
  }

  // If we didn't find a name before the phone number, try the name patterns
  if (!parsed.name) {
    for (const pattern of namePatterns) {
      const match = text.match(pattern);
      if (match && match[1]) {
        parsed.name = match[1].trim();
        break;
      }
    }
  }

  // If we still don't have a phone number, try the other patterns
  if (!parsed.phone) {
    for (const pattern of phonePatterns) {
      const match = text.match(pattern);
      if (match && match[1]) {
        // Clean up phone number - remove all non-digits
        parsed.phone = match[1].replace(/\D/g, '');
        break;
      }
    }
  }

  // Try to find email
  const emailMatch = text.match(/\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?\b/i);
  if (emailMatch) {
    parsed.email = emailMatch[0].toLowerCase();
  }

  return parsed;
};
